function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Upload, InputNumber, Flex, Space, Radio, Image, Alert, notification } from 'antd';
import ImgCrop from 'antd-img-crop';
import { PlusCircleFill, EnvelopeAtFill, TelephoneFill } from "react-bootstrap-icons";
import axios from 'axios';
import Common from "../includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var BookTicket = function BookTicket(_ref) {
  var handler = _ref.handler,
    event = _ref.event;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    pmList = _useState6[0],
    setPmList = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    pg = _useState8[0],
    setPg = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    ticketPrice = _useState10[0],
    setTicketPrice = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    totalAmount = _useState12[0],
    setTotalAmount = _useState12[1];
  var _useState13 = useState(1),
    _useState14 = _slicedToArray(_useState13, 2),
    ticketQuantity = _useState14[0],
    setTicketQuantity = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    apList = _useState16[0],
    setApList = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    apOptions = _useState18[0],
    setApOptions = _useState18[1];
  var _useState19 = useState(1),
    _useState20 = _slicedToArray(_useState19, 2),
    receptionMode = _useState20[0],
    setReceptionMode = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    accessPlan = _useState22[0],
    setAccessPlan = _useState22[1];

  /* const onFinish = (values) => {   
       setIsFormLoading(true);
       setErrorMessage(''); 
       const formData = new FormData();
       formData.append('name', values.name);
       formData.append('amount', totalAmount);
       formData.append("send_method", receptionMode);
       formData.append('event_id', event.id);  
       formData.append('price_schema_item_id', values.plan);
       if(receptionMode == 0) { 
           formData.append('email', values.email);  
           formData.append('email_confirmation', values.email_confirmation); 
       }
       formData.append('mobile', values.mobile);
       formData.append('mobile_confirmation', values.mobile_confirmation);
       formData.append('quantity', values.quantity); 
       formData.append('payment_gateway_id', values.payment_gateway_id); 
       formData.append('user_id', (Common.currentUser==null || Common.currentUser=='undefined') ? 0 : Common.currentUser.id); 
    
       axios.post(Common.baseApiUrl+'bookticket', formData)
       .then(response=>{
           setIsFormLoading(false);    
           if(response.data.status==201){         
               console.log(JSON.stringify(response.data));
               window.location.href = response.data.payment_url;
           }else{   
               setErrorMessage(response.data.message);
           }
       }).catch(error=>{ 
           window.scrollTo(0, 0);
           setIsFormLoading(false);
           setErrorMessage('Une erreur s\'est produite, '+error.message); 
       })
   } */
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    formData.append('name', values.name);
    formData.append('amount', totalAmount);
    formData.append("send_method", receptionMode);
    formData.append('event_id', event.id);
    formData.append('price_schema_item_id', values.plan);
    if (receptionMode == 0) {
      formData.append('email', values.email);
      formData.append('email_confirmation', values.email_confirmation);
    }
    formData.append('mobile', values.mobile);
    formData.append('mobile_confirmation', values.mobile_confirmation);
    formData.append('quantity', values.quantity);
    formData.append('payment_gateway_id', values.payment_gateway_id);
    formData.append('user_id', Common.currentUser == null || Common.currentUser == 'undefined' ? 0 : Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'bookticket', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.code == 0) {
        console.log(JSON.stringify(response.data));
        window.location.href = response.data.payment_url;
      } else {
        setErrorMessage(response.data.error_message);
      }
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };
  var handleQuantityChange = function handleQuantityChange(v) {
    setTicketQuantity(v);
    setTotalAmount(ticketPrice * v);
  };
  var handlePriceChange = function handlePriceChange(v) {
    var ap = apList.filter(function (i) {
      return i.id == v;
    })[0];
    if (apList.filter(function (i) {
      return i.id == v;
    }).length > 0) {
      setTicketPrice(ap.price);
      setTotalAmount(ap.price * ticketQuantity);
      setAccessPlan(apList.filter(function (i) {
        return i.id == v;
      })[0]);
    }
  };
  useEffect(function () {
    if (event.price_schema_items.length > 0) {
      setTicketPrice(event.price_schema_items[0].price);
      setTotalAmount(event.price_schema_items[0].price * ticketQuantity);
    }
    axios.all([axios.get(Common.baseApiUrl + 'getpgs'), axios.get(Common.baseApiUrl + 'geteventplans/' + event.id.toString())]).then(function (response) {
      if (response[0].data.status == 200) {
        setPmList([]);
        response[0].data.pgs.forEach(function (pg) {
          setPmList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: pg.id,
              label: /*#__PURE__*/_jsxs(Flex, {
                gap: "small",
                justify: "center",
                align: "center",
                vertical: true,
                children: [/*#__PURE__*/_jsx(Image, {
                  preview: false,
                  width: "210px",
                  src: "drawables/" + pg.logo
                }), /*#__PURE__*/_jsx("b", {
                  children: pg.label
                })]
              })
            }]);
          });
        });
        if (response[0].data.pgs.length > 0) {
          form.setFieldsValue({
            payment_gateway_id: response[0].data.pgs[0].id
          });
          setPg(response[0].data.pgs.filter(function (g) {
            return g.pdcode == 'CC';
          })[0]);
        }
      }
      if (response[1].data.status == 200) {
        setApList([]);
        response[1].data.plans.forEach(function (p) {
          setApOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: "".concat(p.label, "(").concat(p.price.toLocaleString("Fr"), ")")
            }]);
          });
        });
        if (response[1].data.plans.length > 0) {
          form.setFieldsValue({
            plan: response[1].data.plans[0].id
          });
          setAccessPlan(response[1].data.plans[0]);
        }
        setApList(response[1].data.plans);
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue, verifiez votre connexion internet " + error.toString()
      });
    });
    if (Common.currentUser != 'undefined' && Common.currentUser != null) form.setFieldsValue({
      name: "".concat(Common.currentUser.firstname, " ").concat(Common.currentUser.lastname),
      email: Common.currentUser.email,
      mobile: Common.currentUser.mobile.slice(3)
    });
    form.setFieldsValue({
      quantity: 1
    });
  }, []);
  /*useEffect(() => {           
      if(accessPlan == null)   {  
          alert("noo");
          return; 
      } 
      if(pg == null)   {
          alert("naa"); 
          return;
      } 
      alert(accessPlan.id);     
      axios.post(Common.baseApiUrl+'getpaycardpaylink' , {    
          event_id: event.id,       
          price_schema_item_id : accessPlan.id,          
          quantity : ticketQuantity,    
          payment_gateway_id :  pg.id,         
      }).then(response => {      
          console.log(response);         
      }).catch(error => {   
          console.log("Erreur - "+error.toString());   
      }).finally(() => { 
           
      });   
  }, [totalAmount, accessPlan, pg, ticketQuantity]); */
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "middle",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "name",
        rules: [{
          required: true,
          message: 'Veuillez entrer votre nom'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Entrez votre nom ici"
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          sm: 8,
          xs: 8,
          children: /*#__PURE__*/_jsx(Form.Item, {
            size: "large",
            label: "Type de pass",
            name: "plan",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: apOptions,
              onChange: handlePriceChange
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          sm: 4,
          xs: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            size: "large",
            label: "Nbre de Tickets",
            name: "quantity",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              onChange: handleQuantityChange,
              style: {
                width: "90px"
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              addonBefore: /*#__PURE__*/_jsx(TelephoneFill, {}),
              placeholder: "Numero de T\xE9l\xE9phone",
              style: {
                width: "100%"
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile_confirmation",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              addonBefore: /*#__PURE__*/_jsx(TelephoneFill, {}),
              placeholder: "Confirmez votre Numero",
              style: {
                width: "100%"
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Comment voulez-vous recevoir votre ticket ?",
        name: "send_method",
        children: /*#__PURE__*/_jsx(Radio.Group, {
          block: true,
          options: [{
            label: /*#__PURE__*/_jsx("b", {
              children: "Par E-mail"
            }),
            value: 0
          }, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Par SMS"
            }),
            value: 1
          }],
          defaultValue: 1,
          optionType: "button",
          buttonStyle: "solid",
          onChange: function onChange(v) {
            setReceptionMode(v.target.value);
          }
        })
      }), receptionMode == 0 && /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "email",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Input, {
              block: true,
              addonBefore: /*#__PURE__*/_jsx(EnvelopeAtFill, {}),
              placeholder: "Entrer votre e-mail"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "email_confirmation",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Input, {
              block: true,
              addonBefore: /*#__PURE__*/_jsx(EnvelopeAtFill, {}),
              placeholder: "Confirmer votre e-mail"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "payment_gateway_id",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          options: pmList
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: pmList.length == 0 || apOptions.length == 0,
          loading: isFormLoading,
          type: "primary",
          size: "large",
          htmlType: "submit",
          children: /*#__PURE__*/_jsxs("b", {
            children: ["PAYER ", totalAmount.toLocaleString('Fr')]
          })
        })
      })]
    })
  });
};
export default BookTicket;